const user = state => {
  return {
    ...state.user
  }
}

const avatarInformation = state => {
  return {
    fullName: state.user.fullName,
    photoUrl: state.user?.photoUrl
  }
}

const hasPermissionToGetChat = (state, getters, rootState, rootGetters) => {
  return (
    state.user?.permissions?.getChat ||
    rootGetters['channel/staff/isLoggedStaffOnCall']
  )
}
export default {
  user,
  hasPermissionToGetChat,
  avatarInformation
}
